// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-783316","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-81dec0","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-57a104"};